import { Paper, Stack } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'
import { useIntl } from 'react-intl'
import { DeviceSelect } from './DeviceSelect'
import { FolderSourceSettings } from './FolderSourceSettings'
import { HttpPushSourceSettings } from './HttpPushSourceSettings'
import { MilestoneSourceSettings } from './MilestoneSourceSettings'
import { PipelineFormValues } from './VlmPipelineForm'
import { VpApplicationSourceSettings } from './VpApplicationSourceSettings'
import { PatrolSourceSettings } from './patrol/PatrolSourceSettings'

type PipelineInputSourceStepProps = {
  form: UseFormReturnType<PipelineFormValues>
}

export const PipelineInputSourceStep = ({
  form
}: PipelineInputSourceStepProps) => {
  const intl = useIntl()
  const deviceInputProps = form.getInputProps('deviceId')

  const handleDeviceChange = (deviceId: string | null) => {
    if (
      form.values.pipelineType === 'virtual_patrol' &&
      form.values.source.patrolVideoSource === 'rtsp' &&
      deviceId !== form.values.deviceId
    )
      form.setFieldValue('source.patrolCameras', [])

    form.setFieldValue('deviceId', deviceId ?? '')
  }

  return (
    <Paper p="lg" bg="gray.1">
      <Stack gap="xl">
        <DeviceSelect
          label={intl.formatMessage({
            id: 'vlm.pipelines.create.device.label'
          })}
          description={intl.formatMessage({
            id: 'vlm.pipelines.create.device.description'
          })}
          placeholder={intl.formatMessage({
            id: 'vlm.pipelines.create.device.placeholder'
          })}
          {...deviceInputProps}
          onChange={handleDeviceChange}
        />

        {form.values.pipelineType === 'directory' && (
          <FolderSourceSettings form={form} />
        )}

        {form.values.pipelineType === 'http_push' && (
          <HttpPushSourceSettings form={form} />
        )}

        {form.values.pipelineType === 'visionplatform' && (
          <VpApplicationSourceSettings form={form} />
        )}

        {form.values.pipelineType === 'milestone' && (
          <MilestoneSourceSettings form={form} />
        )}

        {form.values.pipelineType === 'virtual_patrol' && (
          <PatrolSourceSettings form={form} />
        )}
      </Stack>
    </Paper>
  )
}
